/* Suitality mobile menu: replaces the theme slide menu with a full-height panel under the header. */
(function () {
  function ready(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  ready(function () {
    var panel = document.getElementById('SMobileNav');
    if (!panel) return;
    var header = document.getElementById('SiteHeader');
    var triggers = document.querySelectorAll('.mobile-nav-trigger');
    var open = false;
    function place() {
      var r = header ? header.getBoundingClientRect() : { bottom: 0 };
      panel.style.top = Math.max(0, Math.round(r.bottom)) + 'px';
    }
    function set(state) {
      open = state;
      if (open) { place(); panel.hidden = false; requestAnimationFrame(function () { panel.classList.add('is-open'); }); }
      else { panel.classList.remove('is-open'); setTimeout(function () { if (!open) panel.hidden = true; }, 200); }
      document.documentElement.classList.toggle('s-mnav-lock', open);
      Array.prototype.forEach.call(triggers, function (t) {
        t.classList.toggle('is-active', open);
        t.setAttribute('aria-expanded', open ? 'true' : 'false');
        t.setAttribute('aria-controls', 'SMobileNav');
      });
      if (open) { var f = panel.querySelector('summary, a'); if (f) f.focus({ preventScroll: true }); }
    }
    Array.prototype.forEach.call(triggers, function (t) {
      t.setAttribute('aria-expanded', 'false');
      t.addEventListener('click', function (e) { e.preventDefault(); e.stopImmediatePropagation(); set(!open); }, true);
    });
    document.addEventListener('keydown', function (e) { if (open && e.key === 'Escape') { set(false); if (triggers[0]) triggers[0].focus(); } });
    window.addEventListener('resize', function () { if (open) { if (window.innerWidth > 979) set(false); else place(); } });
    panel.addEventListener('click', function (e) { if (e.target.closest('a')) set(false); });
  });
})();
